<template>
  <div class="ele-body">
    <el-card shadow="never" class="profile-card">
      <div class="setting-content">
        <!-- 美丽的标题 -->
        <div class="profile-title">
          <div class="title-icon">
            <i class="el-icon-user"></i>
          </div>
          <h2>个人中心</h2>
          <p>管理您的账户信息</p>
        </div>

        <el-tabs v-model="active" class="user-info-tabs">
          <el-tab-pane label="用户信息" name="info">
            <div class="user-account-list">
              <div class="user-account-item ele-cell">
                <div class="ele-cell-content">
                  <div class="ele-text-secondary">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;用户名称：{{ form.realname }}</div>
                </div>
              </div>
              <el-divider />
              <div class="user-account-item ele-cell">
                <div class="ele-cell-content">
                  <div class="ele-text-secondary">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;登录名称：{{ form.username }}</div>
                </div>
              </div>
              <el-divider />
              <div class="user-account-item ele-cell">
                <div class="ele-cell-content">
                  <div class="ele-text-secondary">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;入驻时间：{{ form.create_time }}
                  </div>
                </div>
              </div>
              <el-divider />
              <div class="user-account-item ele-cell">
                <div class="ele-cell-content">
                  <div class="ele-text-secondary">
                    API|MerchantAccount：{{ form.mch_id }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a target="_blank"
                      href="https://www.showdoc.com.cn/2082649728061862/9377950865615648">接口文档</a></div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="谷歌登录器" name="account">
              <div class="user-account-list">
                <div class="user-account-item ele-cell">
                  <div class="ele-cell-content">
                    <div>绑定谷歌验证器(Google Authenticator)</div>
                    <div class="ele-text-secondary" v-if="form.is_google === 0">当前未绑定谷歌验证器</div>
                    <div class="ele-text-secondary" v-else>当前已绑定谷歌验证器</div>
                  </div>
                  <el-link type="primary" @click="showupdate" v-if="form.is_google === 0">去绑定</el-link>
                  <el-link type="primary" @click="showupdate" v-else>去修改</el-link>
                </div>
                <el-divider />
              </div>
              <el-form v-show="show" label-width="150px" style="max-width: 600px;padding-top: 40px;">
                <div v-if="form.is_google === 1">
                  <el-form-item label="旧秘钥" prop="secret">
                    <el-input v-model="form.google_token" placeholder="新秘钥(字符串格式)" disabled />
                  </el-form-item>
                  <el-form-item label="旧验证码" prop="oldgooglecode">
                    <el-input v-model="goole.oldgooglecode" placeholder="旧验证码" clearable />
                  </el-form-item>
                </div>
                <el-form-item label="新秘钥(字符串格式)" prop="secret">
                  <el-input v-model="goole.secret" placeholder="新秘钥(字符串格式)" style="width: 340px; margin-right: 10px;"
                    clearable />
                  <el-button type="primary" @click="getYzm()" :loading="loading">随机生成
                  </el-button>
                </el-form-item>
                <el-form-item label="新秘钥(字符串格式)" prop="qrCodeUrl">
                  <div v-if="goole.qrCodeUrl == ''">请先点击生成按钮</div>
                  <img v-else :src=this.goole.qrCodeUrl />
                </el-form-item>
                <el-form-item label="新验证码" prop="googlecode">
                  <el-input v-model="goole.googlecode" placeholder="请输入" clearable />
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="saveGoogle" :loading="loading">验证并绑定
                  </el-button>
                </el-form-item>
              </el-form>
          </el-tab-pane>
          <el-tab-pane label="手机绑定" name="phone">
              <div class="user-account-list">
                <div class="user-account-item ele-cell">
                  <div class="ele-cell-content">
                    <div>绑定手机号码</div>
                    <div class="ele-text-secondary" v-if="!form.phone || form.phone === ''">当前未绑定手机号码</div>
                    <div class="ele-text-secondary" v-else>当前绑定的手机号码：{{ form.phone }}</div>
                  </div>
                  <el-link type="primary" @click="showPhoneUpdate">绑定/修改</el-link>
                </div>
                <el-divider />
              </div>
              <el-form v-show="showPhone" label-width="120px" style="max-width: 600px;padding-top: 40px;">
                <el-form-item label="手机号码" prop="phone">
                  <el-input v-model="phoneForm.phone" placeholder="请输入手机号码" clearable style="width: 400px;" maxlength="11" />
                </el-form-item>
                <el-form-item label="验证码" prop="code">
                  <el-input v-model="phoneForm.code" placeholder="请输入验证码" style="width: 200px; margin-right: 10px;" clearable />
                  <el-button type="primary" @click="sendPhoneCode" :loading="phoneCodeLoading" :disabled="!phoneForm.phone || phoneForm.phone.length !== 11">
                    发送验证码
                  </el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="savePhone" :loading="loading">确认绑定
                  </el-button>
                </el-form-item>
              </el-form>
          </el-tab-pane>
          <el-tab-pane label="邮箱绑定" name="email">
              <div class="user-account-list">
                <div class="user-account-item ele-cell">
                  <div class="ele-cell-content">
                    <div>绑定邮箱地址</div>
                    <div class="ele-text-secondary" v-if="!form.email || form.email === ''">当前未绑定邮箱</div>
                    <div class="ele-text-secondary" v-else>当前绑定的邮箱：{{ form.email }}</div>
                  </div>
                  <el-link type="primary" @click="showEmailUpdate">绑定/修改</el-link>
                </div>
                <el-divider />
              </div>
              <el-form v-show="showEmail" label-width="120px" style="max-width: 600px;padding-top: 40px;">
                <el-form-item label="邮箱地址" prop="email">
                  <el-input v-model="emailForm.email" placeholder="请输入邮箱地址" clearable style="width: 400px;" />
                </el-form-item>
                <el-form-item label="验证码" prop="code">
                  <el-input v-model="emailForm.code" placeholder="请输入验证码" style="width: 200px; margin-right: 10px;" clearable />
                  <el-button type="primary" @click="sendEmailCode" :loading="emailCodeLoading" :disabled="!emailForm.email || !validateEmail(emailForm.email)">
                    发送验证码
                  </el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="saveEmail" :loading="loading">确认绑定
                  </el-button>
                </el-form-item>
              </el-form>
          </el-tab-pane>
          <el-tab-pane label="取款密码" name="password">
              <el-form ref="form" :model="formqk" :rules="rules" label-width="100px"
                style="max-width: 600px;padding-top: 40px;" @keyup.enter.native="save">
                <el-form-item label="旧密码:" prop="oldPassword">
                  <el-input show-password v-model="formqk.oldPassword" placeholder="请输入" />
                </el-form-item>
                <el-form-item label="新密码:" prop="newPassword">
                  <el-input show-password v-model="formqk.newPassword" placeholder="请输入" />
                </el-form-item>
                <el-form-item label="确认密码:" prop="rePassword">
                  <el-input show-password v-model="formqk.rePassword" placeholder="请输入" />
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="save" :loading="loading">确认
                  </el-button>
                </el-form-item>
              </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-card>
  </div>
</template>
<script>
import setting from '@/config/setting';
export default {
  name: 'UserInfo',
  data() {
    return {
      // tab页选中
      active: 'info',
      // 表单数据
      form: {},
      goole: {
        secret: '',
        qrCodeUrl: '',
        googlecode: '',
        oldgooglecode: ''
      },
      formqk: {
        oldPassword: '',
        newPassword: '',
        rePassword: ''
      },
      // 手机绑定表单
      phoneForm: {
        phone: '',
        code: ''
      },
      // 邮箱绑定表单
      emailForm: {
        email: '',
        code: ''
      },
      // 控制显示/隐藏
      showPhone: false,
      showEmail: false,
      // 验证码发送loading状态
      phoneCodeLoading: false,
      emailCodeLoading: false,
      // 表单验证
      rules: {
        oldPassword: [
          { required: true, message: '请输入旧密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' }
        ],
        rePassword: [
          {
            required: true,
            message: '请再次输入新密码',
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (!value) {
                return callback(new Error('请再次输入新密码'));
              } else if (value !== this.form.newPassword) {
                return callback(new Error('两次输入密码不一致'));
              }
              callback();
            }
          }
        ]
      },
      // 保存按钮loading
      loading: false,
      // 是否显示裁剪弹窗
      show: false
    };
  },
  mounted() {
    // 获取用户信息
    this.getUserInfo();
  },
  methods: {
    showupdate() {
      this.show = true;
    },
    // 显示手机绑定表单
    showPhoneUpdate() {
      this.showPhone = true;
      this.phoneForm.phone = '';
      this.phoneForm.code = '';
    },
    // 显示邮箱绑定表单
    showEmailUpdate() {
      this.showEmail = true;
      this.emailForm.email = '';
      this.emailForm.code = '';
    },
    // 验证邮箱格式
    validateEmail(email) {
      const reg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return reg.test(email);
    },
    // 发送手机验证码
    sendPhoneCode() {
      if (!this.phoneForm.phone || this.phoneForm.phone.length !== 11) {
        this.$message.warning('请输入正确的手机号码');
        return;
      }
      this.phoneCodeLoading = true;
      this.$http.post('/index/sendPhoneCode', {
        phone: this.phoneForm.phone
      }).then(res => {
        this.phoneCodeLoading = false;
        if (res.data.code === 0) {
          this.$message.success(res.data.msg || '验证码已发送');
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(e => {
        this.phoneCodeLoading = false;
        this.$message.error(e.message);
      });
    },
    // 发送邮箱验证码
    sendEmailCode() {
      if (!this.emailForm.email || !this.validateEmail(this.emailForm.email)) {
        this.$message.warning('请输入正确的邮箱地址');
        return;
      }
      this.emailCodeLoading = true;
      this.$http.post('/index/sendEmailCode', {
        email: this.emailForm.email
      }).then(res => {
        this.emailCodeLoading = false;
        if (res.data.code === 0) {
          this.$message.success(res.data.msg || '验证码已发送');
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(e => {
        this.emailCodeLoading = false;
        this.$message.error(e.message);
      });
    },
    // 保存手机绑定
    savePhone() {
      if (!this.phoneForm.phone || this.phoneForm.phone.length !== 11) {
        this.$message.warning('请输入正确的手机号码');
        return;
      }
      if (!this.phoneForm.code) {
        this.$message.warning('请输入验证码');
        return;
      }
      this.loading = true;
      this.$http.post('/index/bindPhone', this.phoneForm).then(res => {
        this.loading = false;
        if (res.data.code === 0) {
          this.$message.success(res.data.msg || '手机绑定成功');
          this.showPhone = false;
          this.getUserInfo(); // 重新获取用户信息
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(e => {
        this.loading = false;
        this.$message.error(e.message);
      });
    },
    // 保存邮箱绑定
    saveEmail() {
      if (!this.emailForm.email || !this.validateEmail(this.emailForm.email)) {
        this.$message.warning('请输入正确的邮箱地址');
        return;
      }
      if (!this.emailForm.code) {
        this.$message.warning('请输入验证码');
        return;
      }
      this.loading = true;
      this.$http.post('/index/bindEmail', this.emailForm).then(res => {
        this.loading = false;
        if (res.data.code === 0) {
          this.$message.success(res.data.msg || '邮箱绑定成功');
          this.showEmail = false;
          this.getUserInfo(); // 重新获取用户信息
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(e => {
        this.loading = false;
        this.$message.error(e.message);
      });
    },
    /* 获取当前用户信息 */
    getUserInfo() {
      if (setting.userUrl) {
        this.$http.get(setting.userUrl).then((res) => {
          const result = setting.parseUser ? setting.parseUser(res.data) : res.data;
          if (result.code === 0) {
            // 赋予对象值
            this.form = JSON.parse(JSON.stringify(result.data))
          } else {
            this.$message.error(result.msg);
          }
        }).catch((e) => {
          console.error(e);
          this.$message.error(e.message);
        });
      }
    },
    /**
     * 获取验证码
     */
    getYzm() {
      this.$http.get('/index/getYzm').then((res) => {
        const result = setting.parseUser ? setting.parseUser(res.data) : res.data;
        if (result.code === 0) {
          // 赋予对象值
          this.goole.secret = JSON.parse(JSON.stringify(result.data.secret));
          this.goole.qrCodeUrl = JSON.parse(JSON.stringify(result.data.qrCodeUrl))
        } else {
          this.$message.error(result.msg);
        }
      }).catch((e) => {
        console.error(e);
        this.$message.error(e.message);
      });
    },
    saveGoogle() {
      this.loading = true;
      this.$http.post('/index/saveGoogle', {
        googlecode: this.goole.googlecode,
        oldgooglecode: this.goole.oldgooglecode,
        user_google_secret_key: this.goole.secret
      }).then(res => {
        this.loading = false;
        if (res.data.code === 0) {
          this.$message.success(res.data.msg);
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(e => {
        this.loading = false;
        this.$message.error(e.message);
      });
    },
    /* 保存修改 */
    save() {

      this.loading = true;
      this.$http.post('/index/updatePwdcz', this.formqk).then((res) => {
        this.loading = false;
        if (res.data.code === 0) {
          this.$message.success(res.data.msg);

        } else {
          this.$message.error(res.data.msg);
        }
      }).catch((e) => {
        this.loading = false;
        this.$message.error(e.message);
      });
    }
  }
}
</script>

<style scoped>
.setting-content {
  padding: 20px;
}

/* 标题美化 */
.profile-title {
  text-align: center;
  margin: 20px 0 30px;
  padding: 30px 20px;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
  border-radius: 16px;
  position: relative;
  overflow: hidden;
}

.title-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.25);
}

.title-icon i {
  font-size: 40px;
  color: white;
}

.profile-title h2 {
  font-size: 28px;
  font-weight: 600;
  color: #303133;
  margin: 10px 0;
  position: relative;
  z-index: 1;
}

.profile-title p {
  font-size: 14px;
  color: #909399;
  margin: 0;
  position: relative;
  z-index: 1;
}

.el-card {
  margin-bottom: 15px;
  border-radius: 4px;
}

/* 用户账号绑定列表 */
.user-account-list {
  margin-top: 10px;
  background: #fafbfc;
  padding: 20px;
  border-radius: 12px;
}

.user-account-list .user-account-item {
  padding: 15px;
  border-radius: 8px;
  transition: all 0.3s ease;
  margin-bottom: 8px;
}

.user-account-list .user-account-item:hover {
  background: rgba(102, 126, 234, 0.05);
}

.user-account-list .user-account-item .ele-text-secondary {
  margin-top: 6px;
}

/* tab页签 */
.user-info-tabs ::v-deep .el-tabs__nav-wrap {
  padding-left: 20px;
}

/* 美化输入框 */
::v-deep .el-input__inner,
::v-deep .el-select .el-input__inner {
  border-radius: 8px;
  font-size: 15px;
}

::v-deep .el-input__inner:focus,
::v-deep .el-select .el-input.is-focus .el-input__inner {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.15);
}

::v-deep .el-select-dropdown__item.selected {
  color: #667eea;
  font-weight: 600;
}

/* 美化按钮 */
::v-deep .el-button--primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
  transition: all 0.3s ease;
}

::v-deep .el-button--primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.5);
}

::v-deep .el-button {
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s ease;
}

/* 美化分隔线 */
::v-deep .el-divider {
  margin: 15px 0;
}

/* 美化表单区域 */
::v-deep .el-form-item {
  margin-bottom: 25px;
}

/* 美化tab标签 */
::v-deep .el-tabs__item {
  font-weight: 500;
  font-size: 16px;
}

::v-deep .el-tabs__item.is-active {
  color: #667eea;
  font-weight: 600;
}

::v-deep .el-tabs__active-bar {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

/* 美化链接 */
::v-deep .el-link--primary {
  color: #667eea;
  font-weight: 500;
}

::v-deep .el-link--primary:hover {
  color: #764ba2;
}

/* 响应式 */
@media (max-width: 768px) {
  .profile-title {
    padding: 20px 15px;
  }

  .profile-title h2 {
    font-size: 24px;
  }

  .title-icon {
    width: 60px;
    height: 60px;
  }

  .title-icon i {
    font-size: 30px;
  }
}
</style>

<style>
.ele-text-secondary {
  font-weight: bold;
}
</style>
